const translations = {
  hu: {
    heroTitle: "UltraGreen Certificate",
    heroSubtitle: "Tanúsító védjegy ellenőrzés",
    langToggle: "EN",
    directiveTitle: "EU 2024/825 Direktíva megfelelés",
    directiveText:
      "Az UltraGreen tanúsító védjegy megfelel az Európai Unió 2024/825 irányelvének (Empowering Consumers Directive). A tanúsítási rendszer biztosítja, hogy a környezeti állítások valósak, ellenőrizhetők és nem félrevezetők.",
    badgeIndependent: "Független tanúsítás",
    badgeIso: "ISO 17065 szerinti eljárás",
    badgeTransparent: "Átlátható kritériumrendszer",
    pdfTitle: "Tanúsító védjegy szabályzat összefoglaló v04",
    pdfSubtitle: "A követelményrendszer és kommunikációs szabályzat összefoglalója",
    pdfDownload: "Letöltés",
    pdfUrl: "/ug_szab_summ_hu_v04.pdf",
    fullPolicyTitle: "Tanúsító védjegy szabályzat v04",
    fullPolicySubtitle: "A tanúsító védjegy szabályzatának teljes szövege",
    fullPolicyUrl: "/ug_szab_hu_v04.pdf",
    manualTitle: "Arculati, védjegyhasználati és kommunikációs kézikönyv v01",
    manualSubtitle:
      "A védjegy megjelenítésének, használatának és kommunikációjának részletes útmutatója",
    manualUrl: "/ugc-bm-hu",
    priceTitle: "Díjszabás",
    priceSubtitle: "A tanúsítás éves tag- és licencdíjai (érvényes 2026. június 1-től)",
    priceUrl: "/ugc-price-hu",
    searchTitle: "Tanúsítvány ellenőrzés",
    searchSubtitle:
      "Ellenőrizze, hogy egy összetevő vagy márka megfelel-e az UltraGreen követelményeknek. A termékeken és márkákon található QR-kód beolvasásával is ellenőrizheti a tanúsítványt.",
    searchPlaceholder:
      "Összetevő vagy márkanév keresése, pl. Benzyl Alcohol vagy CAS, EC szám alapján.",
    searchQrNote: "QR-kódról érkezett? A keresés automatikusan elindul.",
    searchStarting: "Kezdjen el keresni!",
    searchTooShort: "Kérjük, adjon meg legalább 4 karaktert!",
    searchNoResults: "Nincs találat.",
    searchHint:
      "A pontosabb találathoz adja meg az összetevő teljes nevét.",
    searchDisclaimer1:
      "Az INCI névvel megjelenő összetevő nem jelenti azt, hogy az kozmetikai termékekben használható vagy arra engedélyezett.",
    searchDisclaimer2:
      "Bármely összetevő kozmetikai termékben való használatát a termék biztonsági értékelésének kell alátámasztania.",
    brandsSectionTitle: "Márkák",
    ingredientsSectionTitle: "Összetevők",
    ctaTitle: "Szeretné tanúsíttatni termékét?",
    ctaSubtitle:
      "Lépjen kapcsolatba velünk a tanúsítási eljárás megindításához",
    ctaButton: "Kapcsolatfelvétel",
    footerCompany:
      "UltraGreen Kft. | 1039 Budapest, Batthyány utca 35/B. | Cg. 01-09-376313",
  },
  en: {
    heroTitle: "UltraGreen Certificate",
    heroSubtitle: "Certification Claim Check",
    langToggle: "HU",
    directiveTitle: "EU 2024/825 Directive Compliance",
    directiveText:
      "The UltraGreen certification mark complies with EU Directive 2024/825 (Empowering Consumers Directive). The certification system ensures that environmental claims are truthful, verifiable, and not misleading.",
    badgeIndependent: "Independent certification",
    badgeIso: "ISO 17065 compliant",
    badgeTransparent: "Transparent criteria",
    pdfTitle: "Certification Trademark Regulation Summary v04",
    pdfSubtitle: "Summary of requirements and communication policy",
    pdfDownload: "Download",
    pdfUrl: "/ug_szab_summ_en_v04.pdf",
    fullPolicyTitle: "Certification Mark Policy v04",
    fullPolicySubtitle: "Full text of the certification mark policy",
    fullPolicyUrl: "/ug_szab_en_v04.pdf",
    manualTitle: "Brand & Certification Manual v01",
    manualSubtitle:
      "Detailed guide to trademark presentation, usage and communication (Hungarian document)",
    manualUrl: "/ugc-bm-hu",
    priceTitle: "Fee schedule",
    priceSubtitle:
      "Annual membership and licence fees for certification, valid from 1 June 2026 (Hungarian document)",
    priceUrl: "/ugc-price-hu",
    searchTitle: "Certification Verification",
    searchSubtitle:
      "Check whether an ingredient or brand meets UltraGreen requirements. You can also verify certification by scanning the QR code on products and brands.",
    searchPlaceholder:
      "Search brands, ingredients e.g. Benzyl Alcohol or by CAS, EC numbers.",
    searchQrNote: "Arrived via QR code? The search starts automatically.",
    searchStarting: "Start searching!",
    searchTooShort: "Please type a longer search query!",
    searchNoResults: "No results.",
    searchHint:
      "You should be more specific with the ingredient name if you don't get the expected result.",
    searchDisclaimer1:
      "An ingredient assigned with an INCI name that appears in the results does not mean it is to be used in cosmetic products nor approved for such use.",
    searchDisclaimer2:
      "The use of any ingredient in cosmetic products must be supported by a safety assessment of the product.",
    brandsSectionTitle: "Brands",
    ingredientsSectionTitle: "Ingredients",
    ctaTitle: "Want to certify your product?",
    ctaSubtitle:
      "Get in touch with us to start the certification process",
    ctaButton: "Contact us",
    footerCompany:
      "UltraGreen Kft. | 1039 Budapest, Batthyány utca 35/B. | Reg. 01-09-376313",
  },
};

export default translations;
